import storeRequest from './request/storeRequest';

export const catalogService = {
  getPages(params) {
    return storeRequest.get('/catalogs/pages/products', { params });
  },
  countPages() {
    return storeRequest.get('/catalogs/pages/products/count');
  },
  postGemPage(data) {
    return storeRequest.post('/catalogs/pages/products', data);
  },
  updateGemPage(id, data) {
    return storeRequest.put(`/catalogs/pages/products/${id}`, data);
  },
  getGemPageId(id) {
    return storeRequest.get(`/catalogs/pages/products/${id}`);
  },
  // legacy methods
  getCatalogs(params) {
    return storeRequest.get('/catalogs/find_by_store', {
      params,
    });
  },
  countCatalogs(params) {
    return storeRequest.get('/catalogs/count', {
      params,
    });
  },
  getCatalog(id) {
    return storeRequest.get('/catalogs/' + id);
  },
  importProductToStore(data) {
    return storeRequest.post('/catalogs/import/products', data);
  },
  getCatalogTags() {
    return storeRequest.get('/catalogs/admin/tags');
  },
  getFbBms(params) {
    return storeRequest.get('/catalogs/facebook-feed/fb-bm', { params });
  },
};
